import { RichTextContent, vars } from '@etg/wings';
import { cx } from '@eti/styles';
import ReadMore from '../../main-layout/read-more/ReadMore';
import { fontSize } from '../../main-layout/read-more/styles';
import { useProductCardContext } from '../../context/ProductCardContext';
import { DYNAMIC_ICON } from '../../utils/dynamic-icons/icons';
import { useDynamicIcon } from '../../utils/dynamic-icons/useDynamicIcon';
import { viReadMoreGrid, viText } from './styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ViReadMore = ({
  className,
  children,
  customGrid
}) => {
  const {
    extraProps,
    productName
  } = useProductCardContext();
  const [icon] = useDynamicIcon(vars.colors.links.default, DYNAMIC_ICON.linkIcon);
  const viReadMorePrefix = extraProps === null || extraProps === void 0 ? void 0 : extraProps.viReadMorePrefix;
  const grid = customGrid !== null && customGrid !== void 0 ? customGrid : viReadMoreGrid;
  const content = children || viReadMorePrefix ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, viReadMorePrefix && /*#__PURE__*/_jsx(RichTextContent, {
      className: cx(fontSize, viText(icon), 'text'),
      id: `${productName}-viReadMorePrefix`,
      children: viReadMorePrefix
    })]
  }) : undefined;
  return /*#__PURE__*/_jsx(ReadMore, {
    className: className,
    customGrid: grid,
    children: content
  });
};
export default ViReadMore;
//# sourceMappingURL=ViReadMore.js.map